import Map from './components/Map';

const PersonnelMap = () => {
  
  return (
    <div className="d-flex flex-column h-100 p-3 rounded-2">
      <h4>Personnel Map</h4>
      <Map />
    </div>
  );
};

export default PersonnelMap;
